// src/pages/usa/puertorico/Isabela.js
import "../../../App.css";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import BackOnly from "../../../components/BackOnly";
import ContactPopup from "../../../components/ContactPopup";
import React, { useState, useEffect } from "react";
import AffiliateBooking from "../../../components/affiliate/AffiliateBooking";
import AffiliateExpedia from "../../../components/affiliate/AffiliateExpedia";
import AffiliateTrip from "../../../components/affiliate/AffiliateTrip";

import { useNavigate } from "react-router-dom";   // ⭐ REQUIRED

// ⭐ STRICT COMMAND: Aguadilla ALWAYS goes back to Puerto Rico map
export const backRoute = "/map/puertorico";

export default function Isabela() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  // ⭐ Send strict back command to BackOnly
  useEffect(() => {
    navigate(".", { state: { backRoute } });
  }, [navigate]);

  return (
    <>
      <Header />

      <div className="visited-back-wrapper">
        <BackOnly />
      </div>


      <div className="page-container" style={{ padding: "12px" }}>
        <h1>Isabela, Puerto Rico</h1>

        <section className="travel-review">
          {/* LEFT COLUMN */}
          <div className="travel-text">
            <h2>🏞️ Discover Isabela, Puerto Rico</h2>

            <p>
  Isabela, located on the northwest coast of Puerto Rico, is a hidden gem for travelers
  looking for beaches, scenery, and a relaxed coastal vibe. With its stunning coastline,
  surf spots, and friendly local atmosphere, Isabela offers a great mix of adventure and
  downtime. From the famous Jobos Beach, known for its surfing and lively energy, to the
  peaceful trails and viewpoints around Guajataca, there’s always something to explore.
  The town has colorful murals, great food spots, and a welcoming community that reflects
  the island’s spirit. Whether you want to catch waves, enjoy nature, or experience local
  culture, Isabela is a must‑visit destination in Puerto Rico.
</p>

            <h3>🚗 Getting There</h3>

            <p>
  Isabela is about a 30–40 minute drive from Aguadilla, making it an easy day trip or an
  overnight stay. You can rent a car from Aguadilla Airport or drive from San Juan
  (about 2.5 hours). The route takes you along the northwest coast with plenty of beach
  stops and scenic viewpoints along the way.
</p>

            <h3>🌟 My Personal Observation</h3>

            <ul>
              <li>
                <div className="place-block">
      <strong>Jobos Beach:</strong> A lively beach known for surfing, great views, and a fun
      atmosphere. It’s a perfect spot to relax, watch surfers, grab food from nearby kiosks,
      or enjoy the sunset. During the day it’s active and social, and in the evening it becomes
      a calm, beautiful place to unwind.
      <br />
      <a
        href="https://www.google.com/maps?q=18.514134292953074,-67.07534578991873"
        target="_blank"
        rel="noopener noreferrer"
      >
        📍 View on Google Maps
      </a>
    </div>
              </li>

              <li>
    <div className="place-block">
      <strong>Guajataca Tunnel:</strong> Built in the early 1900s as part of the island’s
      railway system, this tunnel is now a popular walking and photo spot. The trail takes you
      through the tunnel and opens up to dramatic ocean views and rugged coastline. It’s a great
      place for a short walk, pictures, and enjoying the natural scenery.
      <br />
      <a
        href="https://www.google.com/maps?q=18.489925582573452,-66.959423866831"
        target="_blank"
        rel="noopener noreferrer"
      >
        📍 View on Google Maps
      </a>
    </div>
  </li>

              <li>
                <div className="place-block">
                  <strong>Montones Beach:</strong> A quieter beach with calm waters, perfect for 
                  swimming and relaxing. It's less crowded than Jobo Beach, making it a great spot 
                  for families or those looking for a more peaceful beach experience. The beach 
                  is surrounded by natural beauty, with rocky formations and greenery.
                  <br />
                  <a
                    href="https://www.google.com/maps?q=18.513911450609918, -67.06509586373889"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 View on Google Maps
                  </a>
                 
                  
                </div>
              </li>
            </ul>

            <h3>🥾 Other Hidden Gems</h3>

<ul>

  <li>
    <div className="place-block">
      <strong>Driving the Isabela Coast (Jobos → Villa Pesquera):</strong>
      A scenic coastal loop with ocean views, surf spots, food kiosks, and quiet pull‑offs 
      perfect for photos and sunset stops.
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Villa Montaña Beach Resort:</strong>
      A peaceful beachfront escape where you can relax, walk the gardens, or enjoy a 
      sunset dinner at Eclipse Restaurant — one of the best dining experiences on the 
      northwest coast.
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Weekend Nightlife at Jobos Beach:</strong>
      Jobos transforms on Friday and Saturday nights with music, bars, food trucks, and 
      a lively surf‑town vibe. Great for drinks, dancing, and meeting locals.
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Shacks Beach Hidden Caves:</strong>
      A quiet stretch of coastline with underwater caverns and crystal‑clear water — 
      perfect for snorkeling and exploring on calm days.
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Pozo de Jacinto:</strong>
      A dramatic blowhole and cliffside viewpoint with strong waves and great photo 
      opportunities. Visit during low crowds for the best experience.
    </div>
  </li>

</ul>


            <h3>🛏️ Places to Stay in Isabela </h3>

<p>
  Isabela has some of the best beachfront stays on the northwest coast. These options are
  top‑rated on Booking.com and Expedia, with a couple of local favorites added. Always
  double‑check availability and recent reviews.
</p>

<ul>

  <li>
    <div className="place-block">
      <strong>Villa Montaña Beach Resort:</strong> Upscale beachfront resort with two pools,
      chic dining, and direct access to Playa Montones. One of the highest‑rated stays in the area.
      <em> (Listed on Booking & Expedia)</em>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Parador Villas del Mar Hau:</strong> Colorful beachfront villas at Jobos Beach
      with a pool, restaurant, and relaxed tropical vibe. Great for families and long stays.
      <em> (Listed on Booking & Expedia)</em>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Royal Isabela:</strong> Luxury cliffside casitas with private plunge pools,
      ocean views, and a world‑class golf course. A premium option for couples.
      <em> (Listed on Booking & Expedia)</em>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Bella Surf Inn – Boho Beach Isabela:</strong> A budget‑friendly, boho‑style stay
      near Jobos Beach. Simple, clean, and close to surf spots.
      <em> (Listed on Booking)</em>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Villas del Mar Hau – Direct Booking Options:</strong> Additional villa types,
      beachfront cottages, and studios available only through their official website.
      <em> (Some room types not listed on Booking/Expedia)</em>
    </div>
  </li>

</ul>


           <h3>If you are looking for a place to stay, you can check prices, date and time here.</h3>
            <div className="affiliate-block">
              <AffiliateExpedia />
              <AffiliateBooking />
              <AffiliateTrip />
            </div>

            <h3>🎥 My Travel Videos</h3>

            <p>
              Here are some videos I filmed in Aguadilla. Set the quality to 1080p or
              higher for best viewing.
            </p>

            <p>
              <a
                href="https://youtu.be/W69xVqRW9hc?si=_a0dkVbKpD1PcUxk"
                target="_blank"
                rel="noopener noreferrer"
              >
                Sunset at Jobo Beach
              </a>
            </p>

            <p>
              <a
                href="https://youtu.be/E8cT5HelvOA?si=2tZ3onKdHFEFKmxY"
                target="_blank"
                rel="noopener noreferrer"
              >
                Tunnel to Guajataca Forest
              </a>
            </p>


            
          </div>

          {/* RIGHT COLUMN */}
          <div className="travel-image-column">
            <a
              href="https://youtu.be/W69xVqRW9hc?si=_a0dkVbKpD1PcUxk"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-image-card"
            >
              <img
                src="/images/usa/puertorico/isabela/jobo3.jpg"
                alt="Sunset at Jobo Beach"
              />
            </a>

            <a
              href="https://youtu.be/E8cT5HelvOA?si=2tZ3onKdHFEFKmxY"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-image-card"
            >
              <img
                src="/images/usa/puertorico/isabela/tunel2.jpg"
                alt="Tunnel to Guajataca Forest"
              />
            </a>

           
           

            <img
              src="/images/usa/puertorico/isabela/tunel.jpg"
              alt="Guajataca Tunnel"
            />
            
            <img
              src="/images/usa/puertorico/isabela/tunel4.jpg"
              alt="Guajataca Tunnel"
            />
             <img
              src="/images/usa/puertorico/isabela/sign.jpg"
              alt="Sign"
            />
             <img
              src="/images/usa/puertorico/isabela/jacinto.jpg"
              alt="Pozo de Jacinto "
            />
            <img
              src="/images/usa/puertorico/isabela/jobo.jpg"
              alt="Jobo Beach"
            />
            <img
              src="/images/usa/puertorico/isabela/jobo2.jpg"
              alt="Jobo Beach"
            />
              <img
              src="/images/usa/puertorico/isabela/jobo4.jpg"
              alt="Pozo de Jacinto "
            />
            <img
              src="/images/usa/puertorico/isabela/jpbp7.jpg"
              alt="Jobo Beach"
            />
            <img
              src="/images/usa/puertorico/isabela/villamont.jpg"
              alt="Jobo Beach"
            />
             <img
              src="/images/usa/puertorico/isabela/pueblo.jpg"
              alt="Town of Isabela"
            />
          </div>
        </section>
      </div>

      <div className="email-wrapper">
        <button className="email-link" onClick={() => setOpen(true)}>
          contact@thefindingspot.com
        </button>
      </div>

      <ContactPopup isOpen={open} onClose={() => setOpen(false)} />

      <Footer />
    </>
  );
}
